import React from "react";

interface IProps {
  fields: any[];
  form: {
    email: string;
    password: string;
  };
  onSubmit?: (formData: any) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCancel?: () => void;
}

export default function LoginForm({ form, onSubmit, onChange }: IProps) {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit?.(form);
  };

  return (
    <div className="border-2 p-4 rounded-lg">
      <div className="text-center mb-12">
        <img
          src="https://www.regent.ch/fileadmin/main/images/logo_white.svg"
          alt="Regent Logo"
          width={200}
          height={67}
          className="mx-auto object-contain cursor-pointer drop-shadow-[0_2px_15px_rgba(255,255,255,0.5)]"
        />
      </div>

      <div className="max-w-2xl mx-auto space-y-4">
        <input
          id="user"
          name="email"
          type="text"
          value={form.email}
          onChange={onChange}
          className="w-full px-4 py-3 bg-white/5 border border-white/30 rounded-xl text-white placeholder-blue-200/50
                   focus:outline-none focus:ring-2 focus:ring-blue-200/40 focus:border-transparent
                   shadow-[inset_0_2px_4px_rgba(255,255,255,0.1)]
                   transform transition-all duration-300 focus:translate-y-[-2px] focus:shadow-[0_0_20px_rgba(255,255,255,0.2)]"
          placeholder="Email"
        />

        <input
          id="pass"
          name="password"
          type="password"
          value={form.password}
          onChange={onChange}
          className="w-full px-4 py-3 bg-white/5 border border-white/30 rounded-xl text-white placeholder-blue-200/50
                   focus:outline-none focus:ring-2 focus:ring-blue-200/40 focus:border-transparent
                   shadow-[inset_0_2px_4px_rgba(255,255,255,0.1)]
                   transform transition-all duration-300 focus:translate-y-[-2px] focus:shadow-[0_0_20px_rgba(255,255,255,0.2)]"
          placeholder="Password"
        />

        <button
          type="submit"
          onClick={handleSubmit}
          className="w-full px-4 py-3 bg-gradient-to-r from-blue-900/80 via-blue-800/80 to-blue-900/80 text-white rounded-xl
                   hover:from-blue-800/90 hover:via-blue-700/90 hover:to-blue-800/90
                   focus:outline-none focus:ring-2 focus:ring-blue-200/40 focus:ring-opacity-50
                   transform perspective-1000 hover:translate-y-[-2px] hover:shadow-[0_0_30px_rgba(255,255,255,0.3)]
                   active:translate-y-[1px]
                   transition-all duration-300
                   shadow-[0_4px_12px_rgba(255,255,255,0.15)]
                   border border-white/30"
        >
          Sign in
        </button>
      </div>
    </div>
  );
}
